import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { audienceFromLocation, audienceSites } from "../audience/audienceSites";

const NotFound = () => {
  const site = audienceSites[audienceFromLocation(useLocation())];
  return (
  <main className="flex min-h-[70vh] items-center bg-white px-6 py-28 text-gray-900 dark:bg-[#050507] dark:text-white">
    <div className="mx-auto w-full max-w-3xl">
      <p className="mb-5 text-xs font-semibold uppercase tracking-[0.2em] text-primary">404</p>
      <h1 className="mb-5 font-serif text-5xl font-normal tracking-tight sm:text-6xl">
        We couldn’t find that page.
      </h1>
      <p className="mb-8 max-w-xl text-lg leading-8 text-gray-600 dark:text-white/65">
        The link may have changed.
      </p>
      <Link
        to={site?.base || "/"}
        className="inline-flex min-h-11 items-center gap-2 rounded-lg text-sm font-semibold text-primary outline-none focus-visible:ring-2 focus-visible:ring-primary"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        Back to {site ? "home" : "welcome"}
      </Link>
    </div>
  </main>
  );
};

export default NotFound;
